import { SET_SNAPSHOT_TYPE } from "../../actionTypes/actionsTypes";
import { LocalAction } from "../../types";

export const setSnapshotTypeDisplay = (snapshotType: string): LocalAction => ({
    type: SET_SNAPSHOT_TYPE,
    data: snapshotType
});